import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useGetEditChatMobileContainerProperties } from "./useGetEditChatMobileContainerProperties";
import SelectChatWrapper from "../SelectChatWrapper/SelectChatWrapper.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'EditChatMobileContainer',
  setup(__props) {

const {
  listsContainerHeight,
  lists,
  handleRedirect,
  selectedGroupMembers,
  handleAddGroupMember,
  handleRemoveGroupMember,
  handleSaveAddedMembers,
  isRecommendationsVisible,
} = useGetEditChatMobileContainerProperties();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SelectChatWrapper, {
    "lists-container-height": _unref(listsContainerHeight),
    lists: _unref(lists),
    "is-recommendations-visible": _unref(isRecommendationsVisible),
    "selected-members": _unref(selectedGroupMembers),
    title: _ctx.$t('chat.chatSidebar.EditChatPreview.title'),
    "confirm-title": _ctx.$t('settings.chat.editGroupChat.save'),
    onAddSelected: _unref(handleAddGroupMember),
    onRemoveSelected: _unref(handleRemoveGroupMember),
    onRedirect: _unref(handleRedirect),
    onConfirm: _unref(handleSaveAddedMembers)
  }, null, 8, ["lists-container-height", "lists", "is-recommendations-visible", "selected-members", "title", "confirm-title", "onAddSelected", "onRemoveSelected", "onRedirect", "onConfirm"]))
}
}

})